import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

const Users = () => {
    const [users, setUsers] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [currentPage, setCurrentPage] = useState([1]);
    const { jwtToken } = useOutletContext();

    useEffect(() => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);
        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(
            `${process.env.REACT_APP_BACKEND}/api/users?page=${currentPage}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setUsers(data.users);
                setTotalPages(data.totalPages);
                setCurrentPage(data.currentPage);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [currentPage, jwtToken]);

    return (
        <div>
            <h2>Пользователи</h2>

            <table className="table table-stripped table-hover">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Имя</th>
                        <th>Роль</th>
                        <th>Город</th>
                        <th>Баланс</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((u) => (
                        <tr key={u.id}>
                            <td>{u.id}</td>
                            <td>
                                <Link to={`/users/${u.id}`}>{u.name}</Link>
                            </td>
                            <td>{u.roleTitle}</td>
                            <td>{u.townId && u.town && u.town.name}</td>
                            <td>{u.balanceFormatted}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <nav aria-label="Page navigation example">
                <ul className="pagination">
                    <li className="page-item">
                        <a
                            className="page-link"
                            href="#"
                            aria-label="Previous"
                            onClick={() =>
                                setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                        >
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    {Array.from(Array(Math.min(totalPages, 10)).keys()).map(
                        (p) => (
                            <li
                                key={p}
                                className={`page-item ${
                                    p + 1 === currentPage ? "active" : ""
                                }`}
                            >
                                <a
                                    className="page-link"
                                    href="#"
                                    onClick={() => setCurrentPage(p + 1)}
                                >
                                    {p + 1}
                                </a>
                            </li>
                        )
                    )}
                    <li className="page-item">
                        <a
                            className="page-link"
                            href="#"
                            aria-label="Next"
                            onClick={() =>
                                setCurrentPage((prev) =>
                                    Math.min(prev + 1, totalPages)
                                )
                            }
                        >
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Users;
